import * as types from "../../constants/nfc_card/nfc_card_constants";

const initialState = {
  data: [],
  processing: [],
  completed: [],
  nfcCardError: null,
  message: "",
};

const nfcCardReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.ALL_NFC_CARD_SUCCESS:
      return {
        ...state,
        data: payload ? payload.cards : [],
        nfcCardError: null,
      };

    case types.PROCESSING_NFC_CARD_SUCCESS:
      return {
        ...state,
        processing: payload ? payload.cards : [],
        nfcCardError: null,
      };

    case types.COMPLETED_NFC_CARD_SUCCESS:
      return {
        ...state,
        completed: payload ? payload.cards : [],
        nfcCardError: null,
      };

    case types.UPDATE_NFC_CARD_STATUS_SUCCESS:
    case types.MANUAL_NFC_CARD_SUCCESS:
      return { ...state, message: "Done", nfcCardError: null };

    case types.PROCESSING_NFC_CARD_FAILURE:
    case types.COMPLETED_NFC_CARD_FAILURE:
    case types.ALL_NFC_CARD_FAILURE:
    case types.UPDATE_NFC_CARD_STATUS_FAILURE:
    case types.MANUAL_NFC_CARD_FAILURE:
      return { ...state, nfcCardError: payload ? payload : null };

    default:
      return state;
  }
};

export default nfcCardReducer;
